import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const RealEstateListingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RealEstateListing",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.69 10.54 16.06.82a.335.335 0 0 0-.44 0L5 10.54c-.13.13-.13.34 0 .47l.57.58c.13.12.33.12.46 0l1.31-1.2v11.42h5.73v-7.05c0-.24.2-.44.44-.44h4.69c.24 0 .44.2.44.44v7.05h5.74v-11.4l1.31 1.19c.12.12.32.12.45 0l.57-.58a.32.32 0 0 0 .01-.46l-.02-.02ZM27.61 26.46v-1.2l-10.39 5.96c-.15.09-.32.13-.5.13-.26 0-.52-.1-.71-.3l-4.83-5-8.33 4.71a.99.99 0 0 1-1.36-.37c-.27-.48-.1-1.09.38-1.37l9-5.09a1 1 0 0 1 1.21.18l4.82 4.99 9.72-5.57-1.04-.6 5.33-.71z"
    })
  }));
};